module.exports = __webpack_public_path__ + "static/media/pin.2d7ca9a9.svg";